/**
 * Dictionary Archive JavaScript
 * 
 * Features:
 * - Smooth scroll to letter sections when clicking alphabet nav
 * - Scroll spy: highlights active letter in nav based on scroll position
 * - Desktop only (nav hidden on mobile)
 */

export default class Dictionary {
    constructor() {
      this.nav = document.getElementById('dictionary-alphabet-nav');
      
      // Exit if nav doesn't exist (not on dictionary page)
      if (!this.nav) return;
      
      this.links = this.nav.querySelectorAll('.alphabet-nav-link');
      this.sections = document.querySelectorAll('[id^="letter-"]');
      
      // Exit if no sections found
      if (this.sections.length === 0) return;
      
      this.init();
    }
  
    /**
     * Initialize all functionality
     */
    init() {
      this.setupSmoothScroll();
      this.setupScrollSpy();
    }
  
    /**
     * Smooth scroll to section when clicking nav link
     */
    setupSmoothScroll() {
      this.links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          const targetId = link.getAttribute('href');
          const targetSection = document.querySelector(targetId);
          
          if (targetSection) {
            // Calculate offset for sticky header (adjust if needed)
            const headerOffset = 100; // Adjust based on your header height
            const elementPosition = targetSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    }
  
    /**
     * Scroll spy: highlight active letter in nav based on scroll position
     */
    setupScrollSpy() {
      const options = {
        root: null,
        // Adjust margins to trigger when section is in viewport center
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      };
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Extract letter from section id (e.g., "letter-A" -> "A")
            const letter = entry.target.id.replace('letter-', '');
            this.setActiveLetter(letter);
          }
        });
      }, options);
  
      // Observe all letter sections
      this.sections.forEach(section => {
        observer.observe(section);
      });
    }
  
    /**
     * Update active state in navigation
     * 
     * @param {string} letter - Active letter (A-Z)
     */
    setActiveLetter(letter) {
      this.links.forEach(link => {
        const linkLetter = link.getAttribute('data-letter');
        
        if (linkLetter === letter) {
          // Add active styles
          link.classList.add('bg-primary-100', 'text-primary-600');
        } else {
          // Remove active styles
          link.classList.remove('bg-primary-100', 'text-primary-600');
        }
      });
    }
  }
  